import { R } from '@/features/profile/resources/ProfileResources.resx';
import {
    HorizontalContainer,
    Input,
    toast,
    VerticalContainer,
} from '@/components';
import { fetch } from '@/shared/fetch';
import { ISelfResponse } from '@/shared/interfaces';
import { useAtom } from 'jotai';
import { useMutation } from '@tanstack/react-query';
import { newsletterAtom } from '@/features/profile/widgets/newsletter/model';
import { useHydrateAtoms } from 'jotai/utils';

export type NewsletterProps = {
    isMarketingAccepted: boolean;
    email: string;
    isTopdanmark: boolean;
};

export const Newsletter = ({
    isMarketingAccepted: initialMarketingAccepted,
    email,
    isTopdanmark,
}: NewsletterProps) => {
    useHydrateAtoms([[newsletterAtom, initialMarketingAccepted]]);
    const [isMarketingAccepted, setIsMarketingAccepted] =
        useAtom(newsletterAtom);

    const toggleNewsletterMutation = useMutation({
        mutationFn: async (newValue: boolean) => {
            const url = newValue
                ? `/email/subscribe?email=${encodeURIComponent(email)}&getView=false`
                : `/email/unsubscribe?email=${encodeURIComponent(email)}&getView=false`;

            return fetch<ISelfResponse>(url, 'GET');
        },

        onSuccess: (_, newValue) => {
            setIsMarketingAccepted(newValue);
        },

        onError: (err) => {
            toast.addToast({
                type: 'error',
                message: R.NewsletterErrorMessage + '\n' + err,
                autoClose: true,
            });
        },
    });

    const toggleNewsletterSwitch = (newValue: boolean) => {
        toggleNewsletterMutation.mutate(newValue);
    };

    return (
        <VerticalContainer spacing="lg">
            <h2 id="heading-Newsletter">{R.Newsletter}</h2>

            <HorizontalContainer spacing="sm" className="items-center">
                <Input
                    name="newsletter-switch"
                    type="checkbox"
                    checked={isMarketingAccepted}
                    disabled={toggleNewsletterMutation.isPending}
                    onChange={(event) =>
                        toggleNewsletterSwitch(event.target.checked)
                    }
                    className="form-switch"
                    role="switch"
                />

                <div>{R.NewslettersLabel}</div>
            </HorizontalContainer>

            <VerticalContainer spacing="sm">
                <h5>{R.ConsentTitle}</h5>
                <div className="mb-4 max-w-prose text-sm">
                    {isTopdanmark
                        ? R.TopdanmarkConsentDescription
                        : R.ConsentDescription}
                </div>
            </VerticalContainer>
        </VerticalContainer>
    );
};
